import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ResetPasswordViewModel } from '../../../@posturinn/common-react/core';
import { resetPassword } from '../../../actions/userProfileActions';
import Button from '../../base/button';
import FormikFieldWrapper from '../../base/forms/formikFieldWrapper';
import { StyledErrorMessage } from '../../base/forms/formikFieldWrapper.styles';
import { StyledFormikField } from '../../base/forms/input';
import { H1, P } from '../../base/typography';
import { RawLoader } from '../../loading/loading';
import { resetPasswordInitialValues, resetPasswordSchema } from './landingPagesResetPassword.schema';

interface Props {
	landingPage: string;
	token: string;
	error: boolean;
	errorMessage: string;
}

const LandingPagesResetPassword: FC<Props> = ({ landingPage, token }) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const header = t(`${landingPage}.header`);
	const resetPasswordViewModel = new ResetPasswordViewModel();

	const {
		resetPasswordSuccess,
		resetPasswordError,
		resetPasswordErrorMessage,
		resetPasswordLoading,
	}: {
		resetPasswordSuccess: boolean;
		resetPasswordError: boolean;
		resetPasswordErrorMessage: string;
		resetPasswordLoading: boolean;
	} = useSelector(({ userProfileReducer }) => userProfileReducer);

	return (
		<>
			<H1>{header}</H1>

			{resetPasswordSuccess ? (
				<P>{t('success')}</P>
			) : (
				<>
					{resetPasswordError && <StyledErrorMessage>{resetPasswordErrorMessage}</StyledErrorMessage>}
					<Formik
						initialValues={resetPasswordInitialValues}
						validationSchema={resetPasswordSchema}
						onSubmit={values => {
							resetPasswordViewModel.email = values.email;
							resetPasswordViewModel.password = values.password;
							resetPasswordViewModel.confirmPassword = values.passwordConfirm;
							resetPasswordViewModel.code = encodeURIComponent(token);
							dispatch(resetPassword(resetPasswordViewModel));
						}}>
						{() => (
							<Form>
								<FormikFieldWrapper label={t('email')} name="email" languageComponent="myShipments">
									<StyledFormikField type="text" id="email" name="email" placeholder={t('email')} />
								</FormikFieldWrapper>
								<FormikFieldWrapper
									label={t('page-login.password')}
									name="password"
									languageComponent="myShipments">
									<StyledFormikField
										type="password"
										id="password"
										name="password"
										placeholder={t('page-login.password')}
									/>
								</FormikFieldWrapper>
								<FormikFieldWrapper
									label={t('page-login.retypePassword')}
									name="passwordConfirm"
									languageComponent="myShipments">
									<StyledFormikField
										type="password"
										id="passwordConfirm"
										name="passwordConfirm"
										placeholder={t('page-login.password')}
									/>
								</FormikFieldWrapper>
								{resetPasswordLoading ? (
									<RawLoader />
								) : (
									<Button primary mobileBlock type="submit">
										{t('submit')}
									</Button>
								)}
							</Form>
						)}
					</Formik>
				</>
			)}
		</>
	);
};

export default LandingPagesResetPassword;
